var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreakingofbread(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFD2A4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_187)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 20.7908C22.2303 20.7908 20.7906 22.2305 20.7906 24.0001C20.7906 25.7698 22.2303 27.2095 24 27.2095C25.7696 27.2095 27.2093 25.7698 27.2093 24.0001C27.2093 22.2305 25.7696 20.7908 24 20.7908ZM24 25.6861C23.0703 25.6861 22.314 24.9297 22.314 24.0001C22.314 23.0705 23.0704 22.3142 24 22.3142C24.9296 22.3142 25.6859 23.0705 25.6859 24.0001C25.6859 24.9297 24.9296 25.6861 24 25.6861Z",
    fill: "#161722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1955 18.1956L17.1182 17.1184C15.2774 18.9593 14.2636 21.4033 14.2636 24.0002C14.2636 26.597 15.2774 29.041 17.1183 30.8819L18.1955 29.8047C16.6423 28.2515 15.787 26.1901 15.787 24.0002C15.787 21.8102 16.6423 19.7488 18.1955 18.1956V18.1956Z",
    fill: "#161722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8889 15.8889L14.8117 14.8118C12.3537 17.2697 11 20.5329 11 24.0001C11 27.4673 12.3537 30.7304 14.8117 33.1884L15.8889 32.1112C13.7187 29.9409 12.5234 27.0604 12.5234 24.0001C12.5234 20.9398 13.7187 18.0592 15.8889 15.8889V15.8889Z",
    fill: "#161722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1883 14.8118L32.1111 15.889C34.2813 18.0592 35.4765 20.9398 35.4765 24.0001C35.4765 27.0604 34.2813 29.9409 32.1111 32.1112L33.1883 33.1884C35.6463 30.7304 37 27.4673 37 24.0001C37 20.5329 35.6463 17.2697 33.1883 14.8118V14.8118Z",
    fill: "#161722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8818 17.1184L29.8046 18.1956C31.3577 19.7488 32.213 21.8102 32.213 24.0002C32.213 26.1901 31.3577 28.2515 29.8045 29.8047L30.8817 30.8819C32.7226 29.041 33.7365 26.597 33.7365 24.0002C33.7365 21.4033 32.7227 18.9593 30.8818 17.1184V17.1184Z",
    fill: "#161722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5751 19.4248L27.4979 20.502C28.434 21.4381 28.9494 22.6803 28.9494 23.9999C28.9494 25.3195 28.434 26.5618 27.4979 27.4979L28.5751 28.5751C29.7989 27.3513 30.4729 25.7265 30.4729 23.9999C30.4729 22.2734 29.799 20.6486 28.5751 19.4248Z",
    fill: "#161722"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5021 20.502L19.4249 19.4248C18.2011 20.6486 17.5271 22.2734 17.5271 23.9999C17.5271 25.7265 18.2011 27.3513 19.4248 28.5751L20.5021 27.4979C19.566 26.5618 19.0505 25.3195 19.0505 23.9999C19.0505 22.6803 19.5661 21.4381 20.5021 20.502V20.502Z",
    fill: "#161722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_187"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(11 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakingofbread);
export default __webpack_public_path__ + "static/media/breakingofbread.f4e3d3abb39e3be36d24bad1f41275a0.svg";
export { ForwardRef as ReactComponent };